import { useCallback } from 'react';
import { deleteDoc, doc } from 'firebase/firestore';
import { firestore, currentEntity } from "../libs/firestore";

export default function Item({ id, title, quantity, check }) {
  const removeItem = useCallback(() => {
    deleteDoc(doc(firestore, `entities/${currentEntity}/products`, id))
  }, [id]);

  return (
    <div
      key={id}
      className="flex items-center px-4 py-4 bg-blue-800 rounded-xl"
    >
      <button
        type="button"
        onClick={removeItem}
        className={`${
          check === true ? "ring-2" : ""
        } flex-none mr-4 border-2 border-blue-200 rounded-full w-6 h-6`}
      />
      <div className="font-medium text-blue-200">{title}</div>
      <div className="ml-auto text-blue-200">{quantity}</div>
    </div>
  );
}
